import {
  ClipboardDocumentCheckIcon,
  ShoppingCartIcon,
  Cog6ToothIcon,
  ChartBarIcon,
  CheckCircleIcon,
  ClockIcon,
  RectangleGroupIcon,
  CubeIcon,
  NewspaperIcon,
} from "@heroicons/react/24/outline";
import i18n from "i18next";

export function getProviderMenus() {
  return [
    {
      label: i18n.t("menu.overview"),
      icon: ChartBarIcon,
      link: "/provider-dashboard",
    },
    {
      label: i18n.t("menu.inventory"),
      icon: CubeIcon,
      link: "/inventaire",
    },
    {
      label: i18n.t("menu.news"),
      icon: NewspaperIcon,
      link: "/provider-news",
    },
    /*{
      label: i18n.t("menu.businessSettings"),
      icon: BuildingStorefrontIcon,
      subMenus: [
        {
          label: i18n.t("menu.profileSettings"),
          link: "/provider-dashboard-edit",
          icon: UserGroupIcon,
        },
        {
          label: i18n.t("menu.displaySettings"), 
          link: "/business/display",
          icon: DocumentDuplicateIcon,
        },
        {
          label: i18n.t("menu.subscriptions"), 
          link: "/provider-dashboard-subscriptions",
          icon: CurrencyDollarIcon,
        },
      ],
    },*/
    {
      label: i18n.t("menu.productsAndServices"),
      icon: ClipboardDocumentCheckIcon,
      subMenus: [
        {
          label: i18n.t("menu.products"),
          link: "/provider-dashboard-product-list",
          icon: ShoppingCartIcon,
        },
        {
          label: i18n.t("menu.services"),
          link: "provider-dashboard-service-list",
          icon: RectangleGroupIcon,
        },
      ],
    },
    {
      label: i18n.t("menu.orders"), // Commandes
      icon: ClipboardDocumentCheckIcon,
      subMenus: [
        {
          label: i18n.t("menu.waitingOrders"), // Commandes en attente
          link: "/orders/current",
          icon: ClockIcon,
        },
      ],
    },
    /*/*{
      label: i18n.t("menu.finances"), // Finances
      icon: CurrencyDollarIcon,
      link: "/finances",
    },
    {
      label: i18n.t("menu.customerService"), // Service client
      icon: UserGroupIcon,
      subMenus: [
        {
          label: i18n.t("menu.supportTickets"), // Tickets de support
          link: "/customers/support-tickets",
          icon: DocumentDuplicateIcon,
        },
        {
          label: i18n.t("menu.toCall"), // À appeler
          link: "/customers/to-call",
          icon: PhoneIcon,
        },
      ],
    },
    {
      label: i18n.t("menu.settings"), // Paramètres
      icon: Cog6ToothIcon,
      link: "/settings",
    },*/
  ];
}
